import Icon from '../components/Icon.vue';
Icon.register({
  'balance-scale-right': {
    width: 640,
    height: 512,
    paths: [{
      d: 'M96 464c0-8.8 7.2-16 16-16h176v-294.8c-20.4-8.9-36.1-26.2-43.4-47.5l-132-44.3c-8.4-2.8-12.9-11.9-10.1-20.3l10.2-30.3c2.8-8.4 11.9-12.9 20.3-10.1l117.9 39.5c13.8-24 39.4-40.4 69.1-40.4 44.2 0 80 35.8 80 80 0 3.4-0.6 6.7-1 10l128.4 43c8.4 2.8 12.9 11.9 10.1 20.3l-10.2 30.3c-2.8 8.4-11.9 12.9-20.3 10.1l-142.1-47.6c-4.1 2.8-8.4 5.1-13 7.1v342.8c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-32zM0 304c0-16.2-1.3-8.7 85.1-181.5 17.7-35.3 68.2-35.4 85.9 0 87.1 174.3 85.1 165.8 85.1 181.5h0c0 44.2-57.3 80-128 80s-128-35.8-128-80zM56 288h144l-72-144zM384 432c0-16.2-1.3-8.7 85-181.5 17.7-35.3 68.2-35.4 85.9 0 87.1 174.3 85.1 165.8 85.1 181.5h0c0 44.2-57.3 80-128 80s-128-35.8-128-80h0zM440 416h144l-72-144z'
    }]
  }
});